import { Emoji } from "quill-emoji";
import Quill from "quill";
import editor,{ VueEditor } from "vue2-editor";
import ImageResize from "quill-image-resize-module";
import "@/assets/css/vue-editor.scss";

let initialized = false;

// If you add fonts here then you also have to add them in @assets/css/vue-editor.scss
const fonts = ["roboto", "arial", "serif"];

function defaultToolbar():any[]{

	return  [
		[{ font: fonts}],
		[{ header: [false, 1, 2, 3, 4, 5, 6] },{ size: ["10px","11px","12px","13px","14px","16px","18px","20px"] }],
		["bold", "italic", "underline", "strike"],
		[
			{ align: "" },
			{ align: "center" },
			{ align: "right" },
			{ align: "justify" }
		],
		//[{ header: 1 }, { header: 2 }],
		["blockquote"/*, "code-block"*/],
		[{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
		//[{ script: "sub" }, { script: "super" }],
		[{ indent: "-1" }, { indent: "+1" }],
		[{  color: [] }, { background: [] }],
		["link", "image"/*, "formula"*/],
		//[{ direction: "rtl" }],
		["clean"]
	];
}

function defaultOptions():any {
	return {
		modules: {
			imageResize: {}
		}
	};
}

function initQuill() {
	if (initialized) return;
	const ColorClass = Quill.import("attributors/style/color");
	Quill.register(ColorClass, true);
	const fontsModule = Quill.import("attributors/style/font");
	fontsModule.whitelist = fonts;
	Quill.register(fontsModule, true);
	const size = Quill.import("attributors/style/size");
	size.whitelist = ["10px","11px","12px","13px","14px","16px","18px","20px"];
	Quill.register(size, true);
	let block = Quill.import("blots/block");
	block.tagName = "DIV";
	Quill.register(block, true);
	block = Quill.import("blots/embed");
	block.tagName = "IMG";
	Quill.register(block, true);

	Quill.register("emoji", Emoji);
	Quill.import("modules/keyboard");
	Quill.import("modules/toolbar");
	editor.VueEditor.props.editorToolbar.default = defaultToolbar;

	Quill.register("modules/imageResize", ImageResize);
	editor.VueEditor.props.editorOptions.default = defaultOptions;

	initialized = true;
}

initQuill();

export default VueEditor;

